export default __webpack_public_path__ + "static/assets/no_image.d774973e.png";